module.exports = __webpack_public_path__ + "static/media/mToddlersBanner.c2a1531c.svg";